import { Component } from '@angular/core';

@Component({
  selector: 'xos-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
